import { Box, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import priceWithLabelStyles from './priceWithLabelStyles';
import CarIcon from '../../../../../presentational/icons/CarIcon';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';
import MotorcycleIcon from '../../../../../presentational/icons/MotorcycleIcon';
import useTheme from '@material-ui/core/styles/useTheme';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';
import clsx from 'clsx';

export interface IPriceWithLabel {
  price: IPrice;
  label: JSX.Element | string;
  loading?: boolean;
  priceDisplayType?: PriceDisplayType;
  taxLabel?: string;
  isCache?: boolean;
}

const PriceWithLabel: FunctionComponent<IPriceWithLabel> = ({
  price,
  label,
  loading,
  priceDisplayType = PriceDisplayType.PRIMARY,
  taxLabel,
  isCache = false,
}) => {
  const style = priceWithLabelStyles();
  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();
  const {
    spc: {
      customise: { footer },
    },
  } = useTheme<ISpcTheme>();

  return (
    <Box display="flex" flexDirection="column" justifyContent={'center'} alignItems={'center'}>
      <Box display="flex" flexDirection="row">
        {isComplexModel && (
          <Box component={'span'} className={style.icon}>
            {footer?.showMotorcycleIcon ? <MotorcycleIcon /> : footer?.showCarIcon ? <CarIcon /> : ''}
          </Box>
        )}
        <Price
          data-test={'text:price:total'}
          price={price?.money.amount}
          className={clsx([style.price, { [style.cachePrice]: isCache }])}
          loading={loading}
          priceDisplayType={priceDisplayType}
          currency={price?.money.currency}
          taxLabel={taxLabel}
        />
      </Box>
      <Typography className={style.label} variant={'helpingText'} data-test={'text:price:label'}>
        {label}
      </Typography>
    </Box>
  );
};

export default PriceWithLabel;
